import { useEffect, useState } from 'react';
import { useSite } from '../context/SiteContext';
import { taka } from '../lib/price';
import { CloseIcon, ExcelTile, MenuIcon } from './Icons';

const links = [
  { href: '#curriculum', label: 'কারিকুলাম' },
  { href: '#schedule', label: 'সময়সূচি' },
  { href: '#instructor', label: 'মেন্টর' },
  { href: '#faq', label: 'প্রশ্নোত্তর' },
];

export function Logo({ light }) {
  const { course } = useSite();
  return (
    <a href="#top" className="flex items-center gap-2" aria-label={course.brand}>
      <ExcelTile className="h-8 w-8 text-sm" />
      <span className={`text-lg font-bold leading-none ${light ? 'text-white' : 'text-slate-900'}`}>
        MS Office <span className={light ? 'text-cta-400' : 'text-word-500'}>School</span>
      </span>
    </a>
  );
}

export default function Navbar() {
  const { course } = useSite();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const priceSuffix = course.price != null ? ` ${taka(course.price)}` : '';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-40">
      <nav
        className={`border-b transition ${
          scrolled || open ? 'border-slate-200 bg-white/95 shadow-sm backdrop-blur' : 'border-transparent bg-white/70 backdrop-blur'
        }`}
      >
        <div className="container-x flex h-16 items-center justify-between">
          <Logo />
          <ul className="hidden items-center gap-7 md:flex">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="font-medium text-slate-600 transition hover:text-word-500">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-2">
            {course.enrollmentOpen && (
              <a href="#enroll" className="btn-cta hidden px-4 py-2 text-base sm:inline-flex">
                ভর্তি হোন{priceSuffix}
              </a>
            )}
            <button
              type="button"
              className="rounded-lg p-2 text-slate-700 hover:bg-slate-100 md:hidden"
              onClick={() => setOpen((o) => !o)}
              aria-expanded={open}
              aria-label="মেনু"
            >
              {open ? <CloseIcon className="h-6 w-6" /> : <MenuIcon className="h-6 w-6" />}
            </button>
          </div>
        </div>
        {open && (
          <ul className="container-x space-y-1 pb-4 md:hidden">
            {links.map((l) => (
              <li key={l.href}>
                <a href={l.href} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-2.5 font-medium text-slate-700 hover:bg-slate-100">
                  {l.label}
                </a>
              </li>
            ))}
            {course.enrollmentOpen && (
              <li className="pt-2">
                <a href="#enroll" onClick={() => setOpen(false)} className="btn-cta w-full">
                  ভর্তি হোন{priceSuffix}
                </a>
              </li>
            )}
          </ul>
        )}
      </nav>
    </header>
  );
}
